import React from "react";
import ssoStyles from "../../../assets/css/modules/containers/SSOcontainerMfaAddNewPlan.css";

export default ({ children }) => (
  <div className={ssoStyles.background + " backgroundcolor-mfa"}>
    <div className={ssoStyles.bgimg}>
      <div className={ssoStyles.bgimginnerMFA} />
    </div>
    <div className={ssoStyles.overlay + " background-Mfa"} />
    <div className="container-mfa">
      <div className="row">
        <div className="col-sm-12">
          <div
            className={
              "col-md-10 offset-md-1 col-lg-6 offset-lg-3 " +
              ( ssoStyles.shadowBorderMFA) +
             " " +
              ssoStyles.ssocontainer
            }
          >
            <div className={ssoStyles.childrenContainerMfa}>{children}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
);
